import React, { JSX, useState } from "react";
import { CurrentSessionData } from "../hooks/userSession";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { FormField } from "./ui/form-field";

const RestrictedAccess = ({
  currentSession,
  children,
}: {
  currentSession: CurrentSessionData;
  children: JSX.Element;
}): JSX.Element => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const onLoginClick = () => {
    currentSession.login(username, password);
  };

  return !currentSession.userSessionState.isLoggedIn ? (
    <div className="space-y-4">
      <form className="space-y-4">
        <FormField>
          <Label htmlFor="username">Usuario:</Label>
          <Input
            id="username"
            type="text"
            onChange={(event) => setUsername(event.target.value)}
          />
        </FormField>
        <FormField>
          <Label htmlFor="password">Contraseña:</Label>
          <Input
            id="password"
            type="password"
            onChange={(event) => setPassword(event.target.value)}
          />
        </FormField>
      </form>
      <Button onClick={onLoginClick}>Login</Button>
    </div>
  ) : (
    <div>{children}</div>
  );
};

export default RestrictedAccess;
